export const updateUserInfo = (state,args) => {
  return state.userInfo = args
}
export const updateOrderData = (state,args) => {
  return state.orderData = args
}
export const updateFulfillmentConfirmData = (state,args) => {
  return state.fulfillmentConfirmData = args
}
export const area = (state,args) => {
  return state.areaInfo = args
}
export const updateAreaVersionId = (state,args) => {
  return state.areaVersionId = args
}
// export const updateBasicArray = (state,args) => {
//   return state.basic_array = args
// }
// export const updateBasicEnterArray = (state,args) => {
//   return state.basic_enter_array = args
// }
// export const updateMaixiangArray = (state,args) => {
//   return state.maixiang_array = args
// }
// export const updateShangjiaoArray = (state,args) => {
//   return state.shangjiao_array = args
// }
// export const updateZhongjiaoArray = (state,args) => {
//   return state.zhongjiao_array = args
// }
// export const updateXiajiaoArray = (state,args) => {
//   return state.xiajiao_array = args
// }
// export const updateConsultInfo = (state,args) => {
//   return state.consultInfo = args
// }





// WEBPACK FOOTER //
// ./src/store/mutations.js